import type { FoodKind } from '@roadworld/shared';

/** Emoji icon for each food kind. Used in the HUD inventory slots and toast messages. */
export const FOOD_ICONS: Record<FoodKind, string> = {
  pizza: '🍕',
  burger: '🍔',
  sushi: '🍣',
  coffee: '☕',
  taco: '🌮',
  noodles: '🍜',
  icecream: '🍨',
};

export function foodIcon(kind: FoodKind): string {
  return FOOD_ICONS[kind] ?? '🍴';
}
